"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M20.998 2.675a2.69 2.69 0 00-.115-.878 1.066 1.066 0 00-.788-.714 2.944 2.944 0 00-.758-.082H4.663a2.704 2.704 0 00-.864.114 1.058 1.058 0 00-.716.789 2.07 2.07 0 00-.071.488A1.027 1.027 0 013 2.508V17.69c.013.124.028.249.04.373a.982.982 0 00.214.544c.147.167.332.296.539.376l3.714 1.563 3.644 1.536c.125.053.25.113.376.163a1.307 1.307 0 001.033-.04c2.064-.888 4.14-1.745 6.21-2.62.473-.2.947-.402 1.422-.6.183-.074.35-.182.493-.318a.88.88 0 00.25-.51c.037-.23.056-.462.056-.695.007-4.803.009-9.98.007-14.789zm-7.277 13.183h-3.443c-1.523 0-1.955-.528-1.955-1.066 0-.77 2.25-1.755 2.25-2.448 0-1.274-1.502-1.804-1.502-3.737 0-1.73 1.262-3.135 2.82-3.135h.216c1.558 0 2.82 1.405 2.82 3.135 0 1.933-1.502 2.463-1.502 3.737 0 .696 2.25 1.679 2.25 2.448 0 .536-.431 1.066-1.954 1.066z" }), "AccountServices");
//# sourceMappingURL=AccountShield.js.map